import styled, {useTheme} from "styled-components";
import {FlexBox, MarginBox} from "../ui/styled";
import React, {useMemo, useState} from "react";

const OverviewWrapper = styled.div`
  background-color: ${props => props.theme.color.site_main_color};
  border-radius: 6px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 16px;
`;
const HeadBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  background-color: ${props => props.theme.color.white_200};
  padding: 5px 0 5px 16px;
`;
const TitleBox = styled.span`
  font-weight: 600;
  font-size: 15px;
  color: ${props => props.theme.color.dark_100};
  margin-left: 8px;
`;
const BaseContentBox = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
`;
const ContentBox = styled(BaseContentBox)`
  height: 320px;
  padding: 24px 10px;
`;
const FinalContentBox = styled(BaseContentBox)`
  height: 269px;
  padding: 16px 28.5px;
`;
const SLLTextWrapper = styled.div`
  margin-left: 8px;
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 12px;
`;

const LoserBracketAbsolute = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  position: absolute;
  left: 14px;
  bottom: 24px;
`;
const FinalBracketAbsolute = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  position: absolute;
  left: 28.5px;
  bottom: 16px;
`;
const LogoBox = styled.div`
  margin-right: 25px;
`;
const FinalLogoBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
const GroupText = styled.div`
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 18px;
  color: ${props => props.theme.color.dark_200};
  margin-top: 6px;
`;

const FinalGroupText = styled.div`
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 18px;
  color: ${props => props.theme.color.dark_200};
  margin-left: 8px;
`;

const BoundAbsolute = styled.div`
  z-index: 2;
  border-radius: 6px;
  position: absolute;
  right: 10px;
  top: 69px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid ${props => props.theme.color.green_100};
  background: ${props => props.theme.color.green_200};
  padding: 9px 6.4px 15px 6.5px;
  height: 167px;
`;

const BracketText = styled.div`
  text-align: center;
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 14px;
  text-transform: uppercase;
  white-space: pre-wrap;
  color: ${props => props.theme.color.green_100};
`;

const MiddleConnector = styled.div`
  width: 1px;
  height: ${props => {
    let height = '17px'
    if (props.midConHeight) {
      height = props.midConHeight
    }
    return height
  }};
  background-color: ${props => {
    let color = props.theme.color.dark_300;
    if (props.isWin) {
      color = props.theme.color.green_100;
    }
    return color;
  }};;
`;
const LastConnector = styled.div`
  width: ${props => props.width};
  height: 1px;
  background-color: ${props => {
    let color = props.theme.color.dark_300;
    if (props.isWin) {
      color = props.theme.color.green_100;
    }
    return color;
  }};
`;
const TeamColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
const UpperTeamFlex = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  & + & {
    margin-top: 11px;
  }
`;


const FinalTeamFlex = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  & + & {
    margin-top: 16px;
  }
`;


const TeamWithLine = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;




`;


const LoserTeamColumn = styled.div`
  ${TeamWithLine} + ${TeamWithLine} {
    margin-top: 40px;
  }
`;
const FinalTeamColumn = styled.div`
  ${TeamWithLine} + ${TeamWithLine} {
    margin-top: 16px;
  }
`;


const LoserFinal = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  bottom: -16px;
`;


const ChartTeamWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${props => {
    let color = props.theme.color.white_200;
    if (props.isWin) {
      color = props.theme.color.white_100;
    }
    return color;
  }};
  padding: 0 0 0 8px;
  width: 128px;
  height: 32px;
  border-width: 0.5px 4px 0.5px 0.5px;
  border-style: solid;
  border-color: ${props => {
    let color = props.theme.color.dark_300;
    if (props.isWin) {
      color = props.theme.color.green_100;
    }
    return color;
  }}
`;

const TeamText = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: ${props => {
    let color = props.theme.color.theme === 'dark' ? '#B2B2C2' : '#C3D1DC'
    if (props.isWin === 'win') {
      color = props.theme.color.dark_100
    } else if (props.isWin === 'lose') {
      color = props.theme.color.theme === 'dark' ? '#666666' : '#C3D1DC'
    } else if (props.hasTeam) {
      color = props.theme.color.dark_100
    }

    return color
  }};
`;
const TeamConnectorLine = styled.div`
  width: ${props => props.conWidth};
  height: 1px;
  background-color: ${props => {
    let color = props.theme.color.dark_300;
    if (props.isWin) {
      color = props.theme.color.green_100;
    }
    return color;
  }};
`;

const MiddleConnectorAbsolute = styled.div`
  position: absolute;
  ${props => {
    if (props.isBottom) {
      return `bottom:0`
    }
    return 'top:0'
  }};
  right: 0;
  z-index: ${props => {
    let zIndex = '0';
    if (props.isWin) {
      zIndex = '1';
    }
    return zIndex
  }}
`;
const LineBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`

const TeamLittleSpan = styled.span`
  font-weight: 400;
  font-size: 10px;
  color: ${props => {
    let color = props.theme.color.theme === 'dark' ? '#666666' : '#AFB2BF'
    if (props.isWin === 'win') {
      color = props.theme.color.dark_200
    } else if (props.isWin === 'lose') {
      color = color = props.theme.color.theme === 'dark' ? '#666666' : '#C3D1DC'
    } else if (props.hasTeam) {
      color = color = props.theme.color.dark_200
    }
    return color
  }};
  margin-left: 2px;
`;

const SelectListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
`;
const SelectItem = styled.button`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 96px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 12px;
  color: ${props => {
    let color = props.theme.color.theme === 'dark' ? '#666666' : '#C3D1DC';
    if (props.selected) {
      color = props.theme.color.dark_100
    }
    return color
  }};
`;
const SelectedBar = styled.div`
  position: absolute;
  bottom: -6px;
  height: 3px;
  width: 100%;
  background-color: ${props => props.theme.color.green_100};
  z-index: 2;
`;
const SelectBigText = styled.span`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 18px;
`;


const SllOverview = ({list, teamName}) => {
    const theme = useTheme();
    const [selectedGroup, setSelectedGroup] = useState('A')

    const selectedData = useMemo(() => {
        try {
            const result = list[selectedGroup]
            if (result.length > 0) {
                return result
            }
            return []
        } catch (e) {
            return []
        }
    }, [selectedGroup]);

    return (
        <OverviewWrapper>
            <HeadBox>
                <FlexBox height={'auto'} justifyContent={'flex-start'}>
                    <img src={`images/sll/icon_sll_trophy.png`} alt={''} width={22} height={22}
                    />
                    <SLLTextWrapper>
                        <img src={`${theme.icon.path}/sll/icon_sll_sll.png`} alt={''} width={35} height={12}
                        />
                    </SLLTextWrapper>
                    <TitleBox>
                        토너먼트 대진표
                    </TitleBox>
                </FlexBox>
                <SelectListWrapper>
                    <SelectItem onClick={() => setSelectedGroup('A')} selected={selectedGroup === 'A'}>
                        <span>
                        GROUP <SelectBigText>A</SelectBigText>
                            </span>
                        {selectedGroup === 'A' && <SelectedBar/>}
                    </SelectItem>
                    <SelectItem onClick={() => setSelectedGroup('B')} selected={selectedGroup === 'B'}>
                        <span>
                        GROUP <SelectBigText>B</SelectBigText>
                        </span>
                        {selectedGroup === 'B' && <SelectedBar/>}
                    </SelectItem>
                    {/*<SelectItem onClick={() => setSelectedGroup('FINALS')} selected={selectedGroup === 'FINALS'}>*/}
                    {/*    <span>*/}
                    {/*    FINALS*/}
                    {/*    </span>*/}
                    {/*    {selectedGroup === 'FINALS' && <SelectedBar/>}*/}
                    {/*</SelectItem>*/}
                </SelectListWrapper>
            </HeadBox>
            {selectedData.length > 0 &&
                (selectedGroup !== 'FINALS' ?
                    <ContentBox>
                        <GroupBracket groupData={selectedData} groupName={selectedGroup}/>
                    </ContentBox>
                    :
                    <FinalContentBox>
                        <FinalBracket groupData={selectedData}/>
                    </FinalContentBox>)
            }
        </OverviewWrapper>
    )
}

const Winner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  right: 28.5px;
  width: 168px;
  height: 104px;
  padding: 13px 12px 16px 12px;
  border: 1px solid ${props => props.theme.color.green_100};
  background: ${props => props.theme.color.green_200};
  border-radius: 6px;
  top: 52px;
`;

const WinnerTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
`;
const SLLText = styled.span`
  text-align: center;
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 22px;
  color: ${props => props.theme.color.green_100};
`;
const FinalBracket = ({groupData}) => {
    const {isWin,} = useLeague({})
    const theme = useTheme()
    const winnerBracketFirstMatch = useMemo(() => groupData[0], [groupData])
    const winnerBracketSecondMatch = useMemo(() => groupData[1], [groupData])
    const winnerBracketLastMatch = useMemo(() => groupData[2], [groupData])

    const boundWinner = useMemo(() => {
        const winner = winnerBracketLastMatch.find((data) => data.isWin === 1);
        if (!winner) {
            return {team: "????", isWin: -1}
        }
        return winner
    }, [winnerBracketLastMatch]);

    return (
        <div>
            <FinalLeague matches={{
                first: winnerBracketFirstMatch,
                second: winnerBracketSecondMatch,
                last: winnerBracketLastMatch
            }}/>
            <FinalBracketAbsolute>
                <FinalLogoBox>
                    <img src={`${theme.icon.path}/sll/icon_sll_league.png`} alt={''}/>
                    <FinalGroupText>
                        FINALS
                    </FinalGroupText>
                </FinalLogoBox>
            </FinalBracketAbsolute>
            <Winner>
                <WinnerTextWrapper>
                    <SLLText>
                        SLL
                    </SLLText>
                    <BracketText>
                        WINNER
                    </BracketText>
                </WinnerTextWrapper>
                <ChartTeam isWin={'win'} team={boundWinner.team}
                           hasTeam={true} noCon={true}
                           isWinner={true}
                />
            </Winner>
        </div>
    )
}

const FinalLeague = ({matches}) => {
    const {calcHasTeam, findWhoWin, isFinishedMatch, isWin,} = useLeague({matches})

    const firstWinner = useMemo(() => findWhoWin(matches.first), [matches]);
    const secondWinner = useMemo(() => findWhoWin(matches.second), [matches]);


    return (
        <UpperTeamFlex>
            <TeamColumn>
                <FinalTeamFlex>
                    <FinalTeamColumn>
                        <ChartTeam isWin={isWin(matches.first[0].isWin)} team={matches.first[0].team}
                                   hasTeam={calcHasTeam(matches.first)} midConHeight={'25px'}
                                   conWidth={'42px'}
                        />
                        <ChartTeam isBottom={true} isWin={isWin(matches.first[1].isWin)} team={matches.first[1].team}
                                   hasTeam={calcHasTeam(matches.first)}
                                   midConHeight={'25px'}
                                   conWidth={'42px'}
                        />
                    </FinalTeamColumn>
                    <LastConnector isWin={isFinishedMatch(matches.first[0].isWin, matches.first[1].isWin)}
                                   width={'10px'}/>
                    <ChartTeam isWin={isWin(firstWinner.isWin)} midConHeight={'49px'}
                               team={firstWinner.team} hasTeam={calcHasTeam(matches.last)}
                               conWidth={'27px'}

                    />

                </FinalTeamFlex>

                <FinalTeamFlex>
                    <FinalTeamColumn>
                        <ChartTeam isWin={isWin(matches.second[0].isWin)} team={matches.second[0].team}
                                   hasTeam={calcHasTeam(matches.second)}
                                   midConHeight={'25px'}
                                   conWidth={'42px'}
                        />
                        <ChartTeam isBottom={true} isWin={isWin(matches.second[1].isWin)}
                                   team={matches.second[1].team}
                                   hasTeam={calcHasTeam(matches.second)}
                                   midConHeight={'25px'}
                                   conWidth={'42px'}
                        />
                    </FinalTeamColumn>
                    <LastConnector isWin={isFinishedMatch(matches.second[0].isWin, matches.second[1].isWin)}
                                   width={'10px'}/>
                    <ChartTeam isWin={isWin(secondWinner.isWin)} midConHeight={'49px'} isBottom={true}
                               team={secondWinner.team}
                               hasTeam={calcHasTeam(matches.last)}
                               conWidth={'27px'}
                    />
                </FinalTeamFlex>

            </TeamColumn>
            <LastConnector isWin={isFinishedMatch(matches.last[0].isWin, matches.last[1].isWin)}
                           width={'185px'}
            />
        </UpperTeamFlex>
    )
}


const GroupBracket = ({groupData, groupName}) => {
    const theme = useTheme()
    const winnerBracketFirstMatch = useMemo(() => groupData[0], [groupData])
    const winnerBracketSecondMatch = useMemo(() => groupData[1], [groupData])
    const winnerBracketLastMatch = useMemo(() => groupData[2], [groupData])
    const loserBracketFirstMatch = useMemo(() => groupData[3], [groupData])
    const loserBracketLastMatch = useMemo(() => groupData[4], [groupData])

    const boundWinner = useMemo(() => {
        const winner = winnerBracketLastMatch.find((data) => data.isWin === 1);
        if (!winner) {
            return {team: "????", isWin: -1}
        }
        return winner
    }, [winnerBracketLastMatch]);
    const loserWinner = useMemo(() => {
        const winner = loserBracketLastMatch.find((data) => data.isWin === 1);
        if (!winner) {
            return {team: "????", isWin: -1}
        }
        return winner
    }, [loserBracketLastMatch]);

    const calcHasTeam = (team) => {
        if (team[0].team !== '????' || team[1].team !== '????') {
            return true
        }
        return false
    }

    return (
        <div>
            <WinnerBracket matches={{
                first: winnerBracketFirstMatch,
                second: winnerBracketSecondMatch,
                last: winnerBracketLastMatch
            }}/>
            <LoserBracketAbsolute>
                <LogoBox>
                    <img src={`${theme.icon.path}/sll/icon_sll_league.png`} alt={''}/>
                    <GroupText>
                        GROUP {groupName}
                    </GroupText>
                </LogoBox>
                <LoserBracket matches={{
                    first: loserBracketFirstMatch,
                    last: loserBracketLastMatch
                }}/>
            </LoserBracketAbsolute>
            <BoundAbsolute>
                <ChartTeam noCon={true} isWin={boundWinner.team !== '????' ? 'win' : "none"} team={boundWinner.team}
                           hasTeam={calcHasTeam([boundWinner, loserWinner])}/>
                <BracketText>
                    {`Semifinals\nBound!`}
                </BracketText>
                <ChartTeam noCon={true} isWin={loserWinner.team !== '????' ? 'win' : "none"} team={loserWinner.team}
                           hasTeam={calcHasTeam([boundWinner, loserWinner])}/>
            </BoundAbsolute>
        </div>
    )
}

const BracketRelative = styled.div`
  position: relative;
`;
const BracketAbsolute = styled.div`
  width: 128px;
  text-align: center;
  position: absolute;
  top: -19px;
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 12px;
  color: #fff;
`;
const WinnerBracket = ({matches}) => {
    const {calcHasTeam, findWhoWin, isFinishedMatch, isWin,} = useLeague({matches})

    const firstWinner = useMemo(() => findWhoWin(matches.first), [matches]);
    const secondWinner = useMemo(() => findWhoWin(matches.second), [matches]);

    return (
        <UpperTeamFlex>
            <TeamColumn>
                <UpperTeamFlex>
                    <TeamColumn>
                        <ChartTeam isWin={isWin(matches.first[0].isWin)} team={matches.first[0].team}
                                   hasTeam={calcHasTeam(matches.first)}/>
                        <ChartTeam isBottom={true} isWin={isWin(matches.first[1].isWin)} team={matches.first[1].team}
                                   hasTeam={calcHasTeam(matches.first)}
                        />
                    </TeamColumn>
                    <LastConnector isWin={isFinishedMatch(matches.first[0].isWin, matches.first[1].isWin)}
                                   width={'10px'}/>
                    <BracketRelative>
                        <ChartTeam isWin={isWin(firstWinner.isWin)} midConHeight={'38.5px'}
                                   team={firstWinner.team} hasTeam={calcHasTeam(matches.last)}
                                   conWidth={'12px'}
                        />
                        <BracketAbsolute>
                            <span>UPPER BRACKET</span>
                        </BracketAbsolute>
                    </BracketRelative>
                </UpperTeamFlex>

                <UpperTeamFlex>
                    <TeamColumn>
                        <ChartTeam isWin={isWin(matches.second[0].isWin)} team={matches.second[0].team}
                                   hasTeam={calcHasTeam(matches.second)}/>
                        <ChartTeam isBottom={true} isWin={isWin(matches.second[1].isWin)}
                                   team={matches.second[1].team}
                                   hasTeam={calcHasTeam(matches.second)}
                        />
                    </TeamColumn>
                    <LastConnector isWin={isFinishedMatch(matches.second[0].isWin, matches.second[1].isWin)}
                                   width={'10px'}/>
                    <ChartTeam isWin={isWin(secondWinner.isWin)} midConHeight={'38.5px'} isBottom={true}
                               team={secondWinner.team}
                               hasTeam={calcHasTeam(matches.last)}
                               conWidth={'12px'}
                    />
                </UpperTeamFlex>

            </TeamColumn>
            <LastConnector isWin={isFinishedMatch(matches.last[0].isWin, matches.last[1].isWin)}
                           width={'173px'}
            />
        </UpperTeamFlex>
    )
}

const LoserBracket = ({matches}) => {
    const {isWin, isFinishedMatch, findWhoWin, calcHasTeam, findOtherPlayer} = useLeague({matches})


    const firstWinner = useMemo(() => findWhoWin(matches.first), [matches]);
    const otherWinner = useMemo(() => findOtherPlayer(firstWinner), [matches]);

    return (
        <UpperTeamFlex>
            <TeamColumn>
                <UpperTeamFlex>
                    <LoserTeamColumn>
                        <BracketAbsolute>
                            <span>LOWER BRACKET</span>
                        </BracketAbsolute>
                        <ChartTeam isWin={isWin(matches.first[0].isWin)} midConHeight={'37px'}
                                   team={matches.first[0].team} hasTeam={calcHasTeam(matches.first)} conWidth={'12px'}/>
                        <ChartTeam isBottom={true} isWin={isWin(matches.first[1].isWin)} midConHeight={'37px'}
                                   team={matches.first[1].team} hasTeam={calcHasTeam(matches.first)} conWidth={'12px'}/>
                    </LoserTeamColumn>
                    <LastConnector isWin={isFinishedMatch(matches.first[0].isWin, matches.first[1].isWin)}
                                   width={'13px'}/>
                    <UpperTeamFlex>
                        <LoserFinal>
                            <LoserTeamColumn>
                                <BracketAbsolute>
                                    <span>LAST CHANCE</span>
                                </BracketAbsolute>
                                <ChartTeam midConHeight={'37px'} team={otherWinner.team}
                                           isWin={isWin(otherWinner.isWin)} hasTeam={calcHasTeam(matches.last)}
                                           conWidth={'12px'}/>
                                <ChartTeam midConHeight={'37px'} team={firstWinner.team}
                                           isWin={isWin(firstWinner.isWin)} hasTeam={calcHasTeam(matches.last)}
                                           conWidth={'12px'} isBottom={true}/>

                            </LoserTeamColumn>
                            <LastConnector isWin={isFinishedMatch(matches.last[0].isWin, matches.last[1].isWin)}
                                           width={'20px'}/>
                        </LoserFinal>
                    </UpperTeamFlex>
                </UpperTeamFlex>
            </TeamColumn>
            {/*<LastConnector isWin={true} width={'60x'}/>*/}
        </UpperTeamFlex>
    )
}

const ChartTeam = ({team, isWin, isBottom, noCon, hasTeam, midConHeight, conWidth, isWinner}) => {
    return (
        <TeamWithLine>
            <ChartTeamWrapper isWin={isWin === 'win'}>
                {isWinner &&
                    <MarginBox margin={'0 8px 0 0'}>
                        <img src={'/images/ico_best_player01.svg'}/>
                    </MarginBox>
                }
                <TeamText isWin={isWin} hasTeam={hasTeam}>{team}</TeamText>
                <TeamLittleSpan isWin={isWin} hasTeam={hasTeam}>
                    team
                </TeamLittleSpan>
            </ChartTeamWrapper>
            {!noCon &&
                <LineBox>
                    <TeamConnectorLine isWin={isWin === 'win'} conWidth={conWidth || '8px'}/>
                    <MiddleConnectorAbsolute isBottom={isBottom} isWin={isWin === 'win'}>
                        <MiddleConnector isWin={isWin === 'win'} midConHeight={midConHeight}/>
                    </MiddleConnectorAbsolute>
                </LineBox>
            }
        </TeamWithLine>
    )
}


const useLeague = ({matches}) => {
    const isWin = (value) => {
        if (value === 0) {
            return 'lose'
        } else if (value === 1) {
            return 'win'
        } else if (value === -1) {
            return 'none'
        }
    }

    const isFinishedMatch = (value1, value2) => {
        if (value1 >= 0 || value2 >= 0) {
            return true
        } else {
            return false
        }
    }

    const findWhoWin = (match) => {
        const winner = match.find((data) => data.isWin === 1);
        if (!winner) {
            return {team: "????", isWin: -1}
        }
        const lastWinner = matches.last.find((data) => winner.team === data.team);
        if (!lastWinner) {
            return {team: "????", isWin: -1}
        }
        return lastWinner
    }
    const calcHasTeam = (team) => {
        if (team[0].team !== '????' || team[1].team !== '????') {
            return true
        }
        return false
    }
    const findOtherPlayer = (winner) => {
        if (!winner) {
            return {team: "????", isWin: -1}
        }
        const lastWinner = matches.last.find((data) => winner.team !== data.team);
        if (!lastWinner) {
            return {team: "????", isWin: -1}
        }
        return lastWinner
    }
    return {
        calcHasTeam,
        findWhoWin,
        isFinishedMatch,
        isWin,
        findOtherPlayer
    }
}


export default SllOverview